import { Helmet } from "react-helmet-async";

const SITE = "https://makershub.be";
const DEFAULT_OG = `${SITE}/assets/brand/og-banner.png`;

type SeoProps = {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  ogType?: "website" | "article";
  noindex?: boolean;
  schema?: Record<string, unknown> | Record<string, unknown>[];
};

export function Seo({
  title,
  description,
  path,
  ogImage = DEFAULT_OG,
  ogType = "website",
  noindex = false,
  schema,
}: SeoProps) {
  const url = `${SITE}${path}`;
  const robots = noindex ? "noindex,follow" : "index,follow,max-image-preview:large,max-snippet:-1";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="nl-be" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      <meta name="robots" content={robots} />

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="nl_BE" />
      <meta property="og:site_name" content="Makers Hub" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
